import { memo } from 'react';

import { Typography } from 'antd';

import img101 from '../../assets/images/Kraal-colour-white-stacked.webp';

const { Title, Text } = Typography;

function AuthAside({ title, text, subtext }) {
  return (
    <div className="p-5">
      {title && (
        <Title level={3} className="text-white mb-3">
          {title}
        </Title>
      )}
      {text && <Text className="d-inline-block text-white font-20">{text}</Text>}

      {subtext && <Text className="d-inline-block text-white font-20 mt-3">{subtext}</Text>}

      <div className="logo-place login-form-logo">
        <img alt="Kraal Logo" src={img101} width={332} height={234} />
      </div>
    </div>
  );
}

export default memo(AuthAside);
